import { createSelector } from '@reduxjs/toolkit';

const selectUserAccountManagementState = state => state.userAccountManagement;

export const selectManagedUser = createSelector(
  [selectUserAccountManagementState],
  userAccountManagement => userAccountManagement.managedUser
);

export const selectManagedUserFullName = createSelector(
  [selectManagedUser],
  managedUser => {
    if (!managedUser) return null;
    const { firstName, lastName } = managedUser;
    return firstName || lastName ? `${firstName || ''} ${lastName || ''}`.trim() : null;
  }
);
